@if (authService.isAuthenticated()) {
  <div class="default-layout">
    <app-sidebar [isAdminLayout]="true"></app-sidebar>

    <div class="default-container">
      <main class="default-container__content">
        <router-outlet />
      </main>
    </div>
  </div>
}
